<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <MyBadge :isShow="handlerShowBadge" :value="getUnreadCount" :max="messageMax" type="success">
          <div style="font-weight: bold">{{ user_name }}</div>
        </MyBadge> 
        <!-- <div class="c-avatar">
          <img
            src="img/avatars/6.jpg"
            class="c-avatar-img "
          />
        </div> -->
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>{{ $t('avatarSelect.Account') }}</strong>
    </CDropdownHeader>
    <!-- <CDropdownItem>
      <CIcon name="cil-bell"/> {{ $t('avatarSelect.Notice') }}
      <CBadge color="info" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> {{ $t('avatarSelect.Message') }}
      <CBadge color="success" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <!-- <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <!-- <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>{{ $t('avatarSelect.Set') }}</strong>
    </CDropdownHeader> -->
    <CDropdownItem @click="toAct">
      <CIcon name="cil-user" /> {{ $t('avatarSelect.DataAuthentication') }}
    </CDropdownItem>
    <CDropdownItem @click="toMessage">
      <MyBadge :isShow="handlerShowBadge" :value="getUnreadCount" :max="messageMax" type="success">
        <CIcon name="cil-envelope-closed" /> {{ $t('avatarSelect.LetterMessage') }}
      </MyBadge>
    </CDropdownItem>
    <!-- <CDropdownItem>
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem> -->
    <!-- <CDropdownItem>
      <CIcon name="cil-dollar" /> {{ $t('avatarSelect.PaymentSettings') }}
      <CBadge color="secondary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <!-- <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="mfs-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownDivider/>
    <!-- <CDropdownItem>
      <CIcon name="cil-shield-alt" /> Lock Account
    </CDropdownItem> -->
    <CDropdownItem @click="toLoginOut">
      <CIcon name="cil-lock-locked" /> {{ $t('avatarSelect.Logout') }}
    </CDropdownItem>
  </CDropdown>
</template>

<script>
// import { clearAllCookie } from '../api/clearAllCookie'
import MyBadge from '../components/MyBadge.vue'
export default {
  name: 'TheHeaderDropdownAccnt',
  components: {MyBadge},
  data () {
    return { 
      // clearAllCookie,
      itemsCount: 42,
      messageMax: 99
    }
  },
  created() {
    this.$store.dispatch('getUnreadCount')
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name")
    },
    getUnreadCount() {
      return this.$store.state.unreadCount
    },
    handlerShowBadge() {
      return this.$store.state.isShowBadge
    }
  },
  methods: {
    toAct() {
      this.$router.push("/users/account")
    },
    toMessage() {
      this.$router.push("/users/message")
    },
    toLoginOut() {
      // this.clearAllCookie()
      this.$store.dispatch("Logout")
      // let data = {
      //   type: "logout"
      // }
      // let formData = new FormData()
      // for(let k in data) {
      //   formData.append(k, data[k])
      // }

      // this.$axios({
      //   method: "POST",
      //   url: "/request/user.php",
      //   data: formData
      // }).then(res => {
      //     window.sessionStorage.clear()
      //     window.localStorage.clear()
      //     this.$router.push("/pages/login")
      // })
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>